/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

export default function usePromoCodeFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        code: {
            name: `${prefix}code`,
            type: 'text',
            defaultValue: '',
            label: formatMessage({
                defaultMessage: 'Promo code',
                id: 'use_promo_code_fields.label.promo_code'
            }),
            secondaryLabel: formatMessage({
                defaultMessage: '(optional)',
                id: 'use_promo_code_fields.label.optional'
            }),
            placeholder: formatMessage({
                defaultMessage: 'Promo code',
                id: 'use_promo_code_fields.label.promo_code'
            }),
            rules: {
                required: formatMessage({
                    defaultMessage: 'Enter a coupon code',
                    id: 'use_promo_code_fields.error.enter_coupon_code'
                })
            },
            hideRequiredIndicator: true,
            error: errors[`${prefix}code`],
            control
        }
    }

    return fields
}
